import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ConfigAddressApi, ConfigApi, StoreConfigCoordinatesApi} from "../../../services/Api/types";
import {RootState} from "../../../../reducers";
import LoadingContainer from "../../../components/Common/LoadingContainer";
import NavbarLocationForm from "../../../components/Navbar/NavbarLocationForm";
import {useSessionService} from "../../../services/Session/sessionService";
import {getSession} from "../../../services/Session/reducer";
import {getStoreDefaultConfig} from "../../../services/Store/reducer";
import {ReactComponent as MarkerSVG} from "../../../../images/icons/marker.svg";
import {ReactComponent as LocationSVG} from "../../../../images/icons/location.svg";
import IframeWidget from "../../../utils/IframeWidget";
import PopupModal from "../../../components/Modal/PopupModal";

interface OwnProps {
    config: ConfigApi,
    showModal: boolean,
    onHide: () => void,
    onChange: (address: ConfigAddressApi, coordinates: StoreConfigCoordinatesApi) => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function ChangeLocationMultistoreModal(props: Props) {
    const [errors, setErrors] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingLocation, setLoadingLocation] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [address, setAddress] = useState(props.session.address);
    const {t} = useTranslation();
    const sessionService = useSessionService();

    if (!props.default_config) return null;
    const geolocation = async () => {
        console.log("geolocation");
        setLoadingLocation(true);
        navigator.geolocation.getCurrentPosition(function (position) {
            console.log("geolocationgood");
            sessionService.updateCoordinates({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            });
            props.onChange(props.session.address, {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            });
            setLoadingLocation(false);
        }, (err) => {
            console.log("geolocationwrong");
            if (err && err.message === "User denied Geolocation") {
                alert(t("constraints.internal.user_blocked_geolocation"));
            } else {
                alert(t("constraints.internal.location_fetching_failed"));
            }
            setLoadingLocation(false);
        });
    }
    const save = async () => {
        setLoading(true);
        setErrors([]);

        let addressData = address ? {
            city: address.city,
            street: address.street,
            build_nr: address.build_nr,
            flat_nr: address.flat_nr,
            zip_code: address.zip_code,
            country: address.country ? address.country : props.session?.address?.country
        } : {} as ConfigAddressApi;
        try {
            let data = await sessionService.updateLocation(addressData);
            setLoading(false);
            props.onChange(data?.address, data.coordinates);
            IframeWidget.onHide(onHide)
        } catch (err: any) {
            setLoading(false);
            setErrors(err.errors)
        }
    }
    const onShow = () => {
        setLoadingData(true);
        setAddress(props.session.address)
        setLoadingData(false);
    }
    const onHide = () => {
        setLoadingData(true);
        props.onHide();
    }

    return <PopupModal
        bodyContent={
            <>
                <button
                    className={`btn btn-outline-primary btn-lg w-100 btn-flex btn-spinner${loadingLocation ? " loading" : ""}`}
                    onClick={geolocation}>
                    <span className="left spinner-border spinner-border-sm"/>
                    {t("modules.multistore.field.locate_my_address.title")} <LocationSVG/>
                </button>
                <div className="horizontal-divider">
                    <span>{t("modules.multistore.field.or_provide_data.title")}</span>
                </div>
                <div>
                    {(!props.showModal || loadingData) ? (
                        <LoadingContainer/>
                    ) : (
                        <NavbarLocationForm config={props.default_config}
                                            skipDeliveryAreaErrors={true}
                                            onErrors={(addressErrors: any) => setErrors(addressErrors)}
                                            onChange={(newAddress: any) => setAddress(newAddress)} errors={errors}
                                            address={address}/>
                    )}
                </div>
            </>
        }
        title={t("modules.multistore.field.check_delivery_options.title")}
        show={props.showModal}
        onHide={onHide}
        onShow={onShow}
        headerIcon={<MarkerSVG/>}
        description={t("modules.multistore.field.locate_your_address.title")}
        primaryButton={
            <button className={"btn-spinner w-100 btn-primary btn btn-submit" + (loading ? ' loading' : '')}
                    onClick={save}>
                <span className="left spinner-border spinner-border-sm"/>
                {t("common.action.save")}
            </button>
        }
    />
}


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    default_config: getStoreDefaultConfig(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ChangeLocationMultistoreModal));